import { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { languageList } from '@/constants';

export default function SelectLanguage() {
  const router = useRouter();
  const { i18n } = useTranslation('header');
  const [language, setLanguage] = useState(i18n?.language ?? languageList[0].value);

  const handleChangeLanguage = async () => {
    const newLanguage = language === 'vi' ? 'en' : 'vi';
    const { pathname, query, asPath } = router;
    setLanguage(newLanguage);
    try {
      if (pathname !== '/') {
        // use asPath (actual path) to extract real segments instead of route pattern
        const pathMatch = pathname.match(/\[\.{0,3}(.*?)\]/);
        const paramName = pathMatch?.[1];
        const asPathname = asPath?.split('?')?.[0] || '';
        const asParts = asPathname.split('/');

        const locale = newLanguage;
        const originSlug = asParts[1] || '';
        const middleSlug =
          originSlug === 'promotion' || originSlug === 'promotion-en' ? asParts[2] : undefined;

        // normalize subSlug: handle catch-all (array) and remove leading dots from paramName
        const cleanParamName = paramName?.replace(/^\.+/, '');
        let subSlugValue = '';
        if (cleanParamName) {
          const val = query?.[cleanParamName];
          if (Array.isArray(val)) subSlugValue = val.join('/');
          else subSlugValue = val || '';
        }

        if (!originSlug) {
          // fallback: change locale only if we can't determine originSlug
          router.push({ pathname: pathname ?? '' }, asPath, { locale });
          return;
        }

        const hasSub = !!subSlugValue;

        const newPathname =
          hasSub && cleanParamName ? `/${originSlug}/[${cleanParamName}]` : `/${originSlug}`;

        const newQuery =
          hasSub && cleanParamName
            ? {
                [cleanParamName]: Array.isArray(query?.[cleanParamName])
                  ? query[cleanParamName]
                  : subSlugValue,
              }
            : undefined;

        // build asPath for display
        let displayPath = `/${originSlug}`;
        if (middleSlug) displayPath += `/${middleSlug}`;
        if (subSlugValue) displayPath += `/${subSlugValue}`;

        router.push({ pathname: newPathname ?? '', query: newQuery }, displayPath, { locale });
      } else {
        router.push({ pathname: pathname ?? '' }, asPath, { locale: newLanguage });
      }
    } catch (error) {
      router.push('/404', asPath, { locale: newLanguage });
    }
  };

  const languageItem = languageList.find((item) => item.value !== language);

  return (
    <Box alignItems="center" display="flex">
      <Button
        variant="outlined"
        onClick={handleChangeLanguage}
        sx={{
          mr: 2,
          p: 0.5,
          height: '34px',
          width: '64px',
          borderColor: '#E6E6E6',
          borderRadius: 4,
          backgroundColor: '#F2F2F2',
          '&:hover': {
            borderColor: `#E6E6E6`,
          },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Image alt={languageItem.label} src={languageItem?.icon} width={24} height={24} />
        <Typography sx={{ color: 'black', fontSize: '12px', fontWeight: 500, mr: 0.5 }}>
          {language === 'vi' ? 'VI' : 'EN'}
        </Typography>
      </Button>
    </Box>
  );
}
